import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';

export namespace Passport {
  export interface SchemaPropertyDefinition {
    expiry: OpportunitySchema.StringPropertyDefinition;
    number: OpportunitySchema.StringPropertyDefinition;
  }

  export interface SchemaContract {
    expiry?: string | null;
    number?: string | null;
  }

  export interface Model {
    expiry: string | null;
    number: string | null;
  }

  export function toModel(contract: SchemaContract): Model {
    return {
      expiry: contract.expiry ?? null,
      number: contract.number ?? null
    };
  }

  export function toSchemaContract(model: Model): SchemaContract {
    return {
      expiry: model.expiry,
      number: model.number
    };
  }
}
